import { computed } from 'vue'
import { RateCardNoMatchReason } from '@/gql/graphql'
import { $t } from '@/composables/translation'

// Shared by the surfaces that describe the band even when nothing matched
// (useRateCardBandGuidance, useSupplierRateCardBandGuidance) — the direct-hire
// warning never displays a no-match description, so it doesn't need this.
export const useRateCardNoMatchReasonCopy = () =>
  computed<Record<RateCardNoMatchReason, string>>(() => ({
    [RateCardNoMatchReason.NoRateCard]: $t('No rate card is set up in this currency yet.'),
    [RateCardNoMatchReason.UnsupportedRateType]: $t(
      "This rate type isn't covered by the rate card.",
    ),
    [RateCardNoMatchReason.NoLineInForce]: $t('No rate card line is active on this date.'),
    [RateCardNoMatchReason.NoLineMatchedCriteria]: $t(
      "No rate card line matches this job's criteria.",
    ),
  }))

export const silentRateCardNoMatchReasons = new Set([
  RateCardNoMatchReason.NoRateCard,
  RateCardNoMatchReason.UnsupportedRateType,
])
